import styled from 'styled-components';

const stylingVariables = {
    main_color: '#00a5ad',
    secondary_color: '#993B8B',
    tertiary_color: '#455BA4',
};

type ColorScheme = 'teal' | 'pink' | 'purple';

interface Props {
    colorScheme: ColorScheme;
}

const getColor = (colorScheme: ColorScheme) => {
    switch (colorScheme) {
        case 'teal':
            return stylingVariables.main_color;
        case 'pink':
            return stylingVariables.secondary_color;
        case 'purple':
            return stylingVariables.tertiary_color;
    }
};

export const SectionWrapper = styled('div')`
    background-color: #ffffff;
`;

export const TitleWrapper = styled('div')<Props>`
    border-bottom: 2px solid ${(props) => getColor(props.colorScheme)};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    h2 {
        color: ${(props) => getColor(props.colorScheme)};
        font-weight: 700;
        font-size: 26px;
        line-height: 28px;
        padding-right: 10px;
        margin: 5px 0 12px 0;
        border-right: 2px solid ${(props) => getColor(props.colorScheme)};
    }
    h3 {
        color: ${(props) => getColor(props.colorScheme)};
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
        margin: 5px 0 12px 0;
    }
`;

export const SectionContentWrapper = styled('div')`
`;
